import { useState, type FormEvent } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: '小雨',
    role: '单亲妈妈·教师',
    content: '掌中美母让我重新找回了对自己的关注。每天跟着上面的护肤方案做护理，不仅皮肤变好了，更重要的是我找回了自信。现在面对镜子，我终于能真心地微笑了。',
    avatar: '浅',
  },
  {
    name: '小雅',
    role: '职场妈妈·创业者',
    content: '作为一个忙到飞起的创业妈妈，掌中美母的极简护肤方案简直是我的救星。不用花太多时间，但效果真的很明显。推荐给所有和我一样时间宝贵的妈妈们。',
    avatar: '雅',
  },
  {
    name: '丽丽',
    role: '二胎妈妈·全职主妇',
    content: '生完二宝后我几乎放弃了自己。偶然看到掌中美母的一篇文章，决定试试看。三个月下来，老公都说我像变了一个人。原来为自己花点时间，真的可以这么不一样。',
    avatar: '丽',
  },
];

const brandValues = [
  {
    icon: 'ri-heart-line',
    title: '以妈妈为中心',
    description: '每一位妈妈的需求都是独特的。我们用心倾听，量身定制，确保每一个美丽方案都切实可用。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '科学可信赖',
    description: '所有护肤建议和美丽方案都基于科学研究和专业经验，拒绝伪科学和夸大宣传。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '温暖陪伴',
    description: '我们不只是一个美丽平台，更是妈妈们的温暖伙伴。在这里，你可以找到理解和支持。',
  },
];

function ContactForm() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('loading');
    setFormMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      setFormMessage('您的留言已成功发送，我们会尽快回复！');
      form.reset();
      return;
    }

    formData.delete('website_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9u4q553pcjqs2fcsm70', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('您的留言已成功发送，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        setFormStatus('error');
        setFormMessage(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络异常，请稍后再试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
            姓名 <span className="text-primary-500">*</span>
          </label>
          <input
            type="text"
            id="contact-name"
            name="name"
            required
            className="w-full px-3 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors duration-200"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
            邮箱 <span className="text-primary-500">*</span>
          </label>
          <input
            type="email"
            id="contact-email"
            name="email"
            required
            className="w-full px-3 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors duration-200"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>
      <div>
        <label htmlFor="contact-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
          手机号码
        </label>
        <input
          type="tel"
          id="contact-phone"
          name="phone"
          className="w-full px-3 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors duration-200"
          placeholder="请输入您的手机号码（选填）"
        />
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
          主题 <span className="text-primary-500">*</span>
        </label>
        <select
          id="contact-subject"
          name="subject"
          required
          defaultValue=""
          className="w-full px-3 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors duration-200 cursor-pointer"
        >
          <option value="" disabled>请选择咨询主题</option>
          <option value="护肤咨询">护肤咨询</option>
          <option value="形象建议">形象建议</option>
          <option value="投稿分享">投稿分享</option>
          <option value="合作洽谈">合作洽谈</option>
          <option value="其他问题">其他问题</option>
        </select>
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
          留言内容 <span className="text-primary-500">*</span>
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          className="w-full px-3 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors duration-200 resize-none"
          placeholder="请输入您的留言内容（不超过500字）"
        ></textarea>
        <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <div>
        <button
          type="submit"
          disabled={formStatus === 'loading'}
          className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
        >
          {formStatus === 'loading' ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>
              提交中...
            </>
          ) : (
            <>
              发送留言
              <i className="ri-send-plane-line"></i>
            </>
          )}
        </button>
      </div>

      {formStatus === 'success' && (
        <div className="p-3 rounded-md bg-secondary-50 text-secondary-800 text-sm">
          <i className="ri-check-line mr-1.5"></i>
          {formMessage}
        </div>
      )}
      {formStatus === 'error' && (
        <div className="p-3 rounded-md bg-primary-50 text-primary-700 text-sm">
          <i className="ri-error-warning-line mr-1.5"></i>
          {formMessage}
        </div>
      )}
    </form>
  );
}

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 掌中美母 | 品牌故事与联系方式"
        description="了解掌中美母的品牌故事、核心价值和联系方式。掌中美母为现代母亲打造专属美丽养护方案，帮助每一位妈妈在繁忙生活中找回自信光彩。"
        keywords="掌中美母品牌,妈妈美丽养护品牌,母亲护肤品牌介绍,掌中美母联系方式"
        canonicalPath="/about"
      />

      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-4">
            关于掌中美母
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            掌中美母诞生于一个简单的信念：<strong>每一位妈妈都值得被温柔以待。</strong>
            我们深知，成为母亲并不意味着要放弃自己。相反，成为母亲是女性生命中一个崭新而美好的开始。掌中美母致力于为现代母亲打造专属的美丽养护方案，从肌肤护理到整体形象提升，帮助每一位妈妈在繁忙的生活中找回属于自己的光彩。
          </p>

          <div className="relative rounded-lg overflow-hidden mb-10 h-56 md:h-72">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20elegant%20brand%20studio%20space%20with%20cream%20walls%20and%20soft%20natural%20light%2C%20flowers%20and%20skincare%20products%20artfully%20arranged%2C%20minimalist%20beauty%20brand%20aesthetic%2C%20gentle%20feminine%20atmosphere%2C%20editorial%20interior%20photography&width=1200&height=600&seq=about-brand&orientation=landscape"
              alt="掌中美母品牌形象"
              title="掌中美母品牌形象"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-6 md:mb-8 text-center">
            我们的价值观
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
            {brandValues.map((value, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className={`${value.icon} text-xl text-accent-600`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-6 md:mb-8 text-center">
            妈妈们这样说
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((item, idx) => (
              <div key={idx} className="bg-background-100 rounded-lg p-5 md:p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-semibold text-sm">
                    {item.avatar}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                    <p className="text-xs text-foreground-400">{item.role}</p>
                  </div>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  &ldquo;{item.content}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
                如果你有任何关于美丽养护的问题，想要投稿分享你的故事，或者希望与我们合作，都欢迎通过以下方式联系我们。我们期待听到你的声音。
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-50">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">电子邮箱</p>
                    <p className="text-sm text-foreground-500">hello@zhangzhongmeimu.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-wechat-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">微信公众号</p>
                    <p className="text-sm text-foreground-500">掌中美母</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-phone-line text-secondary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">客服热线</p>
                    <p className="text-sm text-foreground-500">400-888-9999</p>
                    <p className="text-xs text-foreground-400">周一至周五 9:00-18:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-lg p-5 md:p-6">
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-4">
                在线留言
              </h3>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50 text-center">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-4">
            加入掌中美母的美丽社群
          </h2>
          <p className="text-sm text-foreground-600 mb-6 max-w-lg mx-auto">
            关注我们的微信公众号，获取每日美丽养护小贴士，和千万妈妈一起踏上美丽蜕变之旅。
          </p>
          <Link
            to="/category/skin-care"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索美丽方案
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </>
  );
}